import { getGtmData, GtmCustomData, recordEventWrapper } from '..';
import { replaceEmptySpaceWithHyphen } from '../../utils/common';

const investMore = () => ({
  onInvestMorePageLoad: (schemeName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/my-holdings/invest-more/scheme-' + replaceEmptySpaceWithHyphen(schemeName, true),
    //   title: 'PFM - Online Investments - Portfolio - My Holdings - Invest More - Scheme - ' + schemeName,
    //   cd24: getGtmData('cd24'),
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Invest More - ' + schemeName,
    // });
  },
  // data will have cd68, cd69, and cd70 values.
  onClickInvestMorePageContinue: (scheme, data: GtmCustomData, userFlow?, isLumpsum?) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: `mutual funds | ${userFlow?.toLowerCase()} | ${scheme}`,
      label: `continue | ${isLumpsum ? "Lumpsum" : "SIP"}`,
      ...data
    });
  },
  onOTPModalLoad: (schemeName: string, userFlow?) => {
    recordEventWrapper({
      event: 'event_pfm_onload_vpv',
      page: `/vpv/pfm/mutual-funds/${userFlow?.toLowerCase()}/otp-verification`,
      title: `PFM - Mutual Funds - ${userFlow?.toLowerCase()} - OTP Verification`
    }),
    recordEventWrapper({
      event: 'event_pfm_onload',
      category: 'PFM',
      action: 'Pageload',
      label: `mutual funds | ${userFlow?.toLowerCase()} - - otp verification`
    })
  },
  onCloseOtpModal: (schemeName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Invest More - ' + schemeName + ' - Verify OTP - Close',
    // });
  },
  onClickOTPSubmit: (schemeName: string, userFlow?) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: `mutual funds | ${userFlow?.toLowerCase()} - otp verification`,
      label: `success | ${schemeName}`
    });
  },
  // data will have cd71 as value
  onInvestMoreSuccessPageLoad: (schemeName: string, data: GtmCustomData) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page:
    //     'vpv/pfm/online-investments/portfolio/my-holdings/invest-more/scheme-' + schemeName + '/investment-successful',
    //   title:
    //     'PFM - Online Investments - Portfolio - My Holdings - Invest More - Scheme - ' +
    //     schemeName +
    //     ' - Investment Successful',
    //   ...data
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Invest More - ' + schemeName + ' - Investment Successful',
    // });
  },
  onClickBackToMyHoldings: (schemeName: string, goBackMessage: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Invest More - ' + schemeName + ` - Investment Successful - ${goBackMessage}`,
    // });
  },
});

export default investMore;
